const API = {
  // Auth
  SEND_OTP: `/user/send_otp`,
  LOGOUT: `user/logout`,
  VERIFY_OTP: `user/verify_otp`,
  FIRM_VERIFY_OTP: `user/firm_verify_otp`,
  CREATE_ADMIN: "user/create_admin",
  FIRM_CREATE_ADMIN: `user/firm_create_admin`,
  CREATE_COMAPNY: "company/create_company",
  FIRM_CREATE_COMPANY: `company/firm_create_company`,
  GET_MASTER_DATA: `common/get_master_data`,
  GET_LORRY_TYPE: `/settings/get_lorry_type`,
  GET_COMPANY: `user/get_dashboard_data`,
  GET_FIRM_COMPANY: `user/firm_get_dashboard_data`,
  CONSIGNOR_DATA: `account/`,
  UPDATE_CONSIGNOR_: `account/update_consignor`,
  CONSIGNOR_GROUP_DATA: `consignor_group/get_consignor_group`,
  GET_MASTER_ROLE: "menu/add_role_master_data",
  ADD_ROLE: "role/create_role",
  ROLE: `role/get_role`,
  ROLE_DELETE: "role/delete_role",
  CONSIGNOR_GROUP: "consignor_group/get_consignor_group",
  ADD_USER: "user/add_user_to_company",
  FIRM_ADD_USER: `user/firm_add_user_to_company`,
  USER: `user/get_company_users`,
  DELETE_USER: "user/delete_user",
  SETTINGS_DATA: `settings/`,
  MENU: "menu/get_allowed_menus",
  LORRY_RECEIPT: `lr/`,
  LR_DEAULT_COLUMN: "common/reset_user_lr_columns",
  GET_BRANCH: "branch/",
  ROLE_DETAILS: `role/get_role_detail`,
  ROLE_UPDATE: "role/update_role",
  COMMON_DROPDOWN: `common/`,
  ALL_ACCOUNT: `chart_account/get_chart_account`,
  ALL_BRANCH: `common/get_branch_for_dropdown`,
  ALL_ROUTE: `route/get_route`,
  ALL_VEHICLE_NUMBER: "common/get_vehicle_for_dropdown",
  ALL_DRIVERS: "common/get_driver_for_dropdown",
  ALL_SUPPLIER: "common/get_supplier_for_dropdown",
  ADD_ROUTE: `route/add_route`,
  ALL_LR: `lr/apk_lr_list`,
  ALL_LR: `lr/lr_list`,
  ADD_TRIP: `trip/add_trip`,
  TRIP: `trip/trip_list`,
  MATERIAL_DATA: `material/`,
  DISPATCH_TRIP: `trip/get_trip`,
  TOTAL_FREIGHT: `dispatch/add_total_freight`,
  TRANSACTION: `dispatch/trip_transaction_list`,
  UPLOAD_PROFILE_IMAGE: `user/upload_user_avatar`,
  TRIP_SERVIES: `trip/`,
  FREIGHT_TYPE: `common/get_master_category`,
  BANK_LIST: `account/get_bank_account`,
  CHART_OF_ACCOUNT: `chart_account/get_account`,
  ACCOUNT_LIST: `account/get_bank_account`,
  ADD_BANK_ACCOUNT: `account/add_bank_account`,
  UPDATE_USER_LR_COLUMNS: `common/update_user_lr_columns`,
  ADD_ADV_FREIGHT: `dispatch/create_trip_transaction`,
  GET_USER_ACCOUNT: `chart_account/get_account_for_user`,
  TOTAL_FREIGHT_DETAILS: `dispatch/get_total_freight`,
  EDIT_TOTAL_FREIGHT: `dispatch/update_total_freight`,
  EDIT_LR_TOTAL_FREIGHT: `dispatch/update_lr_total_freight`,
  ALL_CITIES_API: `csc/get_citys`,
  ALL_STATE_API: `csc/get_country_states`,
  CREATE_ROUTE: `company/update_company_route`,
  TRIP_TRANSACTION: `dispatch/trip_transactions`,
  TRIP_REVENUE: `dispatch/trip_revenue`,
  //tesing api

  LR_LIST_TRIP: `trip/apk_get_trip_lr`,
  EXPENSE: `dispatch/get_expense_category`,
  USER_ACCOUNT: `user/get_account_from_user`,
  LORRY_RECEIPT_COUNT: `lr/get_lr_count`,
  ACCOUNTING_GET_USER: `user/get_accounting_from_user`,
  CHART_EXPENSE: `chart_account/get_expense_category`,
  COMMON_EXPENSE: `chart_account/get_expense_category`,
  CHART_RECIPT: `chart_account/get_receipt_account`,
  ADVANCE_DRIVER_CAT: `chart_account/get_expense_category`,
  // supplier
  CREATE_SUPPLIER: `account/apk_add_supplier`,
  EDIT_SUPPLIER: `account/apk_edit_supplier`,
  DELETE_SUPPLIER: `account/delete_supplier`,
  GET_SUPPLIER_LIST: `account/get_supplier_list`,
  GET_SINGLE_SUPPLIER: `account/get_supplier`,
  CHANGE_SUPPLIER_STATUS: `account/change_supplier_status`,
  // unit
  CREATE_UNIT: `account/apk_add_unit`,
  EDIT_UNIT: ``,
  DELETE_UNIT: `account/delete_unit`,
  GET_UNIT_LIST: `account/get_unit_list`,
  GET_SINGLE_UNIT: `account/get_unit`,
  CHANGE_STATUS_OF_UNIT: `account/change_unit_status`,
  // consignee
  CREATE_CONSIGNEE: `account/apk_add_consignee`,
  EDIT_CONSIGNEE: ``,
  DELETE_CONSIGNEE: `account/delete_consignee`,
  GET_CONSIGNEE_LIST: `account/get_consignee_list`,
  GET_SINGLE_CONSIGNEE: `account/get_consignee`,
  CHANGE_CONSIGNEE_STATUS: `account/change_consignee_status`,
  // vendor
  CREATE_VENDOR: `account/add_vendor`,
  EDIT_VENDOR: `account/edit_vendor`,
  GET_VENDOR_LIST: `account/get_vendor_list`,
  GET_SINGLE_VENDOR: `account/get_vendor`,
  DELETE_VENDOR: `account/delete_vendor`,
  CHANGE_VENDOR_STATUS: `account/change_vendor_status`,
  // branch
  CREATE_BRANCH: `branch/apk_add_branch`,
  UPDATE_BRANCH: `branch/update_branch`,
  EDIT_BRANCH: ``,
  GET_BRANCH_LIST: `branch/get_branch_list`,
  GET_SINGLE_BRANCH: `branch/get_branch`,
  DELETE_BRANCH: `branch/delete_branch`,
  CHANGE_BRANCH_STATUS: `branch/change_branch_status`,
  UPDATE_SETTING_BRANCH: `branch/update_setting_for_branch`,
  // fuel station
  CREATE_FUEL_STATION: `account/add_fuelstation`,
  EDIT_FUEL_STATION: ``,
  GET_LIST_FUEL_STATION: `account/get_fuelstation_list`,
  SINGLE_FUEL_STATION: `account/get_fuelstation`,
  DELETE_FUEL_STATION: `account/delete_fuelstation`,
  CHANGE_FUEL_STATION_STATUS: `account/change_fuelstation_status`,
  USER_ACCOUNT: `user/get_account_from_user`,
  LORRY_RECEIPT_COUNT: `lr/get_lr_count`,
  ACCOUNTING_GET_USER: `user/get_accounting_from_user`,
  GET_FUEL_STATEMENT: `account/get_fuel_statement`,
  // contract
  CREATE_CONTRACT: `account/add_contract`,
  EDIT_CONTRACT: `account/update_contract`,
  DELETE_CONTRACT: `account/delete_contract`,
  GET_CONTRACT_LIST: `account/get_contract_list`,
  GET_SINGLE_CONTRACT: `account/get_contract`,
  CONTRACT_STATUS_CHANGES: `account/change_contract_status`,
  ACCOUNTING_TRANSACTION: `dispatch/accounting_transactions`,
  PAYNOW_ACCOUNT_TRANSACTION:`dispatch/paynow_transactions`,
  // own driver
  CREATE_OWN_DRIVER: `account/apk_add_own_driver`,
  EDIT_OWN_DRIVER: `account/apk_edit_own_driver`,
  GET_OWN_DRIVER_LIST: `account/get_driver_list`,
  GET_DRIVER_DETAILS: `account/get_driver`,
  CHANGE_DRIVER_STATUS: `account/change_driver_status`,
  DELETE_OWN_DRIVER: `account/delete_driver`,
  // PAYMENT: `dispatch/payment_approval_list`,
  PAYMENT: `payment_approval/get_payment_approval`,

  // PAYMENT_COUNT:`dispatch/get_payment_approval_count`,
  PAYMENT_COUNT: `payment_approval/payment_approval_count`,

  // ADD_CONSIGNOR_CLAIM: `dispatch/create_consignor_transaction`,
  ADD_CONSIGNOR_CLAIM: `dispatch/create_consignor_transaction`,
  ADD_CONSIGNOR_TRANSACTION2: `dispatch/create_consignor_transaction2`,


  // consignor Contract Rates
  CREATE_RATE: `account/add_contract_rates`,
  EDIT_RATE: ``,
  DELETE_RATE: `account/delete_contract_rates`,
  GET_RATE_LIST: `account/get_contract_rate_list`,
  GET_SINGLE_RATE: `account/get_contract_rates`,
  RATE_STATUS_CHANGES: `account/change_contract_rates_status`,
  // accounting chart of account
  CREATE_CHART_ACCOUNT: `chart_account/create_chart_of_account`,
  EDIT_CHART_ACCOUNT: `chart_account/update_chart_of_account`,
  DELETE_CHART_ACCOUNT: `chart_account/delete_chart_of_account`,
  GET_CHART_ACCOUNT_LIST: `chart_account/get_chart_account`,
  GET_SINGLE_CHART_ACCOUNT: `chart_account/get_chart_account`,
  GET_DROPDOWN_CHART_ACCOUNT: `chart_account/get_chart_of_account_type`,
  CONSIGNOR_TRAN: `dispatch/consignor_transactions`,
  // zone
  CREATE_ZONE: `settings/add_zone`,
  EDIT_ZONE: ``,
  GET_ZONE_LIST: `settings/get_zone_list`,
  GET_SINGLE_ZONE: `settings/get_zone`,
  DELETE_ZONE: `settings/delete_zone`,
  // UPDATE_APPROVE: `dispatch/update_payment_approval`,
  UPDATE_APPROVE: `payment_approval/update_payment_approval`,

  // consignor Group
  CREATE_CONSIGNOR_GROUP: `consignor_group/add_consignor_group`,
  EDIT_CONSIGNOR_GROUP: ``,
  GET_CONSIGNOR_GROUP_LIST: `consignor_group/get_consignor_group_list`,
  GET_SINGLE_CONSIGNOR_GROUP: `consignor_group/get_single_consignor_group`,
  DELETE_CONSIGNOR_GROUP: `consignor_group/delete_consignor_group`,
  // vehicle Group
  CREATE_VEHICLE_GROUP: `settings/add_vehicle_group`,
  EDIT_VEHICLE_GROUP: ``,
  GET_VEHICLE_GROUP_LIST: `settings/get_vehicle_group_list`,
  GET_SINGLE_VEHICLE_GROUP: `settings/get_vehicle_group`,
  DELETE_VEHICLE_GROUP: `settings/delete_vehicle_group`,
  // ledget statement
  GET_LEDGER_STATEMENT: `dispatch/get_vendor_statement2`, // get_ledger_statement
  GET_INTER_FIRM_LEDGER_STATEMENT: `interfirm/get_interfirm_statement`,
  // Invoice Bill raise
  CREATE_INVOICE_BILL_RAISE: `billraise/create_billraise`,
  GET_INVOICE_BILL_RAISE_LIST: `billraise/billraised_list`,
  GET_DETAILS_INVOICE_BILL_RAISE: `billraise/get_billraised_lr`,
  GET_SUMMARY_DETAILS: `billraise/get_billraised`,
  GET_CLAIM_LIST_FOR_INVOICE_DETAILS_TAB: `billraise/get_billraised`,
  GET_INVOICE_BILL_RAISE_SUMMARY: `billraise/get_summary_for_billraise`,
  GET_LR_FOR_INVOICE_BILL_RAISE: `billraise/get_lr_for_billraise`,
  CREATE_INVOICE_BILL_RAISE_TEMPLATE: `common/create_LRtemplate`,
  UPDATE_LR_INVOICE_BILL_RAISE: `common/update_template_lr_columns`,
  RESET_LR_INVOICE_BILL_RAISE: `common/reset_template_lr_columns`,
  INVOICE_DETAILS_ADD_PAYMENT: `billraise/billraise_payment`,
  INVOICE_DETAILS_ADD_PAYMENT_LR_TO_LR: `billraise/get_billraised_lr_for_payment`,
  INVOICE_DETAILS_ADD_TDS_LR_TO_LR: `billraise/get_billraised_lr_for_tds`,
  INVOICE_DETAILS_ADD_TDS: `billraise/billraise_tds_receivable`,
  INVOICE_DETAILS_ADD_CLAIM: `billraise/billraise_claim`,
  INVOICE_DETAILS_SELECT_LR_LIST: `billraise/get_lr_billraise_claim`, // pending_lr_for_billraise
  BILL_RAISE_SELECT_CLAIMS_LIST: `billraise/get_claim_for_billraise`,

  //
  // ADD_FUEL_TRAN: `dispatch/create_fuel_transaction`,
  ADD_FUEL_TRAN: `dispatch/create_trip_transaction`,
  END_TRIP: `trip/apk_end_trip`,
  LAST_TRIP: `trip/get_last_trip`,
  BUILTY: `lr/get_bilty`,
  TRIP_COUNT: `trip/get_trip_count`,

  // Add Driver Transaction
  // ADD_DRIVER_TRANSACTION: `dispatch/create_own_trip_transaction`,
  ADD_DRIVER_TRANSACTION: `dispatch/create_trip_transaction`,
  ADD_EWAY_WILL: `lr/add_ewaybill_to_lr`,
  USER_PERMISSION: `user/get_setting_from_user`,
  USER_STATUS: `user/change_user_status_to_company`,
  DELETE_USER: `user/delete_user_to_company`,
  GET_SINGLE_USER: `user/get_setting_from_user`,
  USER_DETAILS: `user/get_company_user_detail`,
  FIRM_USER_DETAILS: `user/firm_get_company_user_detail`,
  GET_ADD_USER_BRANCH: `branch/get_branch_for_user`,
  EDIT_USER: `user/update_user_to_company`,
  UPDATE_FIRM_USER: `user/firm_update_user_to_company`,
  USER_FIRM_DETAILS: `user/get_firms_from_company`,
  //Vehicle Group

  VEHICLE_GROUP: `common/get_vehicle_group_for_dropdown`,

  // Main Dasboard
  GET_DASHBOARD_COUNT: `dashboard/get_dashboard_count`,
  VEHICLE_GROUP: `common/get_vehicle_group_for_dropdown`,
  // lr
  LR_LIST: `lr/lr_list`,
  PLAN: `plan/`,
  ACCOUNT: `account/`,
  FUEL_CARD: `fuelcard/`,
  FASTAG: `fastag/`,
  LR_IMPORT: "lr/import_lr",
  JK_LR_IMPORT: "lr/import_jk_lr",
  ADANI_LR_IMPORT: `lr/import_adani_lr`,

  //address_book
  GET_ADDRESS_BOOK: `account/addressbook_list`,
  CREATE_ADDRESS_BOOK: `account/add_addressbook`,
  DELETE_ADDRESS_BOOK: `account/delete_addressbook`,
  GET_ADDRESS_ASSOCIATE: `common/get_associate_party`,
  GET_FUEL_STATION_DROP: `common/get_fuelstation_for_dropdown`,
  CONTRACT_RATE: `dispatch/get_contract_rates2`,
  GET_ADDTESS_BOOK_DETAILS: `account/get_addressbook`,
  GET_ADDRESS_BOOK: `account/addressbook_list`,
  CREATE_ADDRESS_BOOK: `account/add_addressbook`,
  GET_ADDRESS_ASSOCIATE: `common/get_associate_party`,
  GET_FUEL_STATION_DROP: `common/get_fuelstation_for_dropdown`,
  // CONTRACT_RATE: `dispatch/get_contract_rates`,
  UPDATE_ADDRESS: `account/update_addressbook`,

  //connections services
  GET_CONNECTION_COUNT: `connection/count`,
  GET_SUGGESTION_LIST: `connection/suggestion_list`,
  GET_CONNECTION_LIST: `connection/connection_list`,
  SEND_REQUEST_CONNECTION: `connection/sent_connection_request`,
  WITHDRAWAL_CONNECTION_REQUEST: `connection/withdrawal_request`,
  REJECT_CONNECTION_REQUEST: `connection/reject_request`,
  REMOVE_CONNECTION_REQUEST: `connection/remove_request`,
  ACCEPT_CONNECTION_REQUEST: `connection/accept_request`,
  MARKET_VISIBLITY_LIST: `connection/get_lists`,

  GET_CONNECTION_LISTS: `connection/get_lists`,
  ADD_CONNECTION_LISTS: `connection/add_list`,
  GET_RATINGS_REVIEW_LISTS: `connection/rating_list`,
  ADD_RATINGS_REVIEW: `connection/add_rating`,

  //Inden Service

  CREATE_INDENT: `plan/add_plan`,
  MATERIAL_LIST: `material_type/get_material_type`,
  INDENT_LIST: `plan/plan_list`,
  INDENT_COUNT: `plan/get_plan_count`,
  INDENT_DETAILS_API: `plan/get_plan`,
  INDENT_UPDATE: `plan/update_plan`,
  CLOSE_INDENT: `plan/plan_closed`,
  DISPATCH_INDENT: `plan/plan_dispatch`,
  DELETE_INTENT: `plan/delete_plan`,
  // Market Loads Service

  GET_MARKET_LOAD_LIST: `plan/market_load`,
  CREATE_BID_MARKET_LOAD: `bid/create_bid`,
  UPDATE_BID_MARKET_LOAD: `bid/update_bid`,
  GET_BID_LIST: `bid/bid_list`,
  GET_BID_COUNT: `bid/count`,
  CHANGES_BID_STATUS: `bid/change_bid_status`,
  UPDATE_MARKET_VISIBLITY: `plan/update_market_visibility`,
  // market load mark favorite unfavorite filters
  GET_FAVORITE_LOCATION: `plan/get_favorite_location`,
  SAVE_FAVORITE_LOCATION: `plan/save_favorite_location`,
  RECENT_SEARCH_DATA: `plan/recent_search_list`,

  //account

  CASH_ACCOUNT: `chart_account/add_cash_account`,
  BANK_ACCOUNT: `chart_account/add_bank_account`,
  OTHER_ACCOUNT: `chart_account/add_other_account`,
  FUEL_ACCOUNT: `chart_account/add_fuelcard_account`,
  FASTAG_ACCOUNT: `chart_account/add_fastag_account`,
  ADD_EXPENSE_ACCOUNT: `dispatch/create_accounting_transaction`,
  FUEL_CARD_MASTER: `fuelcard/fc_master_list`,
  ADD_FUEL_CARD_MASTER: `fuelcard/add_fc_master`,
  FUEL_CARD_ACCOUNT_LIST: `fuelcard/get_fc_account`,
  ADD_DRIVER_FROM_TRIP: `trip/add_driver_to_trip`,
  CREATE_FUEL_OUT: `dispatch/create_fuelout_transaction`,
  ADD_EXPENSE_API: `chart_account/add_expense_category`,
  GET_FUEL_RATE: `account/get_fuel_average_rate`,
  DELETE_TRANSACTION: `dispatch/delete_transaction`,
  VENDER_DROPDOWN: `common/get_vendor_for_dropdown`,
  UPDATE_CASH_ACCOUNT: `chart_account/update_cash_account`,
  UPDATE_BANK_ACCOUNT: `chart_account/update_bank_account`,
  UPDATE_OTHER_ACCOUNT: `chart_account/update_other_account`,

  //Report
  PROFIT_AND_LOSS: `reports/profit_and_loss`,
  OWN_VEHICLE_PROFITABILITY: `reports/own_vehicle_profitability`,
  TRIP_DETAILS_REPORT: `reports/trip_report/in_excel`,
  VEHICLE_PROFIT_REPORT: `reports/get/detailed_vehicle_report/in_excel`,
  TRIP_PROFIT_REPORT_EXCEL: `reports/get/trip_profit_report/in_excel`,
  TRIP_REVENUE_REPORT: `reports/get/revenue_report/excel_sheet`,
  GENERAL_LEDGER: `ledger/general_ledger`,
  GENERAL_LEDGER_DETAILS_ACCOUNT_TRANSACTIONS: `ledger/account_ledger`,
  JOURNAL_REPORT_LEDGER: `ledger/journal_report`,
  BALANCE_REPORT: `ledger/balance_sheet`,
  P_AND_L_REPORT: `ledger/profit_and_loss`,
  ALL_VEHICLE_DETAILS_REPORT: `reports/get/allVehiclesReport/in_excel`,

  TRANSFER_FUND: `transfer/fund_trf`,
  CREATE_FUEL_OWN: `dispatch/add_fuel_to_truck`,

  // staff
  CREATE_STAFF: `account/add_staff`,
  EDIT_STAFF: `account/edit_staff`,
  DELETE_STAFF: `account/delete_staff`,
  GET_STAFF_LIST: `account/get_staff_list`,
  GET_SINGLE_STAFF: `account/get_staff`,
  CHANGE_STAFF_STATUS: `account/change_staff_status`,
  GET_ROLE_MASTERS: `menu/get_permission_from_subscription`,
  GET_SINGLE_PLAN_SUBSCRIPTION: ``,
  MENU_2: `menu/get_allowed_menus`,
  GET_CITIES: `csc/get_state_cities`,
  GET_COUNTRY_STATES: `csc/get_country_states`,

  //fasttag
  ADD_FASTAG_MASTER: `fastag/add_ft_master`,
  GET_FASTAG_MASTER: `fastag/ft_master_list`,
  ADD_FASTAG_ACCOUNT: `fastag/add_ft_account`,
  ADD_FUEL_CARD_ACCOUNT: `fuelcard/add_fc_account`,

  GET_FUEL_COMPANY_DROPDOWN: `fuelcard/get_fc_company_for_dropdown`,
  GET_FASTAG_COMPANY_DROPDOWN: `fastag/get_ft_company_for_dropdown`,
  ADD_FUEL_COMPANY: `fuelcard/add_fc_company`,
  FUEL_TXN_LIST: `fuelcard/get_fc_txn`,
  GET_FASTAG_MASTER_DROPDOWN: `fastag/ft_master_list`,
  FUEL_CARD_ACCOUNT_DROPDOWN: `fuelcard/get_fc_account_for_dropdown`,
  GET_FASTAG_ACCOUNT: `fastag/get_ft_account`,
  FASTAG_TXN_LIST: `fastag/fetch_ft_txn`,

  GET_CHART_OF_ACCOUNT_LIST: `ChartOfAccount/getUserChartOfAccount`,
  GET_CHART_OF_ACCOUNT_TYPE_WISE: `ChartOfAccount/getUserChartOfAccount`,
  CREATE_CHART_OF_ACCOUNT: `ChartOfAccount/addUserChartOfAccount`,
  DELETE_CHART_OF_ACCOUNT: `ChartOfAccount/deleteUserChartOfAccount`,

  GET_BUILTY: `lr/get_lr_bilty`,
  GET_BUILTY2: `lr/get_lr_bilty`,
  BUILY_DOWNLOAD: `lr/print_lr_bilty`,
  BUILY_DOWNLOAD2: `lr/print_lr_bilty`,

  PAYMENT_VOUCHER: `dispatch/preview_payment_voucher`,
  MAKE_PAYMENT: `dispatch/make_payment`,
  ADD_LOAD: `trip/add_load`,

  ADD_TRIP_APK: `trip/apk_add_trip`,

  UPDATE_STATUS_ADDRESSBOOK: `account/change_addressbook_status`,

  GET_VEHICLE: `account/get_vehicle`,
  EDIT_VEHICLE: `account/update_vehicle`,
  UPDATE_BRANCH_PLAN: `plan/update_plan_branch`,

  LR_DETAIL_REPORT_EXCEL: `reports/get/lr_report/in_excel`,
  PLAN_EXPORT_EXCEL_REPORT: `reports/get/plan_report/in_excel`,
  DELETE_POD_FILE: `lr/delete_pod`,
  CANCEL_TRIP: `trip/cancel_trip`,

  CREATE_LOCATION: `csc/add_company_city`,
  DELETE_LOCATION: `csc/delete_company_city`,
  UPDATE_LOCATION: `csc/update_company_city`,
  GET_LOCATION_LIST: `csc/get_citys`,
  GET_LOCATION_BY_ID: `csc/get_company_city`,

  ADD_TRIP_CHARGE_MULTI: `dispatch/create_trip_charges`,
  GET_COMPANY_DETAILS: `company/company_detail`,
  UPDATE_COMPANY_END_POINT: `company/update_company`,

  LEDGER_REPORT: `ledger/getLedgerStatement`,
  GPS_INTRIGATION: `gps/integrate_feed`,

  // For GPS Configration and GPS instance

  GET_ALL_VEHICLE_FOR_GPS: `v1/wheelseye/fetch_all_vehicle`,
  GET_TMS_VEHICLE_COUNT: `dashboard/tms_vehicle_status`,
  GET_GPS_STATUS: `v1/wheelseye/gps_vehicle_status`,
  GET_GPS_TIMELINE: `gps/timeline`,
  GET_GPS_VEHICLE: `/dashboard/getGPSVehicle`,

  // masters list download
  ALL_LIST_DOWNLOAD_API: `account/export_vendor_list/in_excel`,
  ALL_ADDRESSBOOK_LIST: `account/export_addressbook_list/in_excel`,

  SAMPLE_UPLOAD: `common/download_sheet_sample`,

  // eway bill

  UPDATE_EWAY_BRANCH: `branch/eway_integration`,
  COMPANY_PROFILE_UPLOAD: `company/upload_company_logo`,
  GET_ALL_LR_FORMATE: `branch/lr_format_by_company`,
  ADD_LR_FORMAT: `branch/add_lr_format_to_branch`,
  GET_LR_FORMAT_BY_BRANCH: `branch/lr_format_by_branch`,
  DELETE_FORMAT_FROM_BRANCH: `branch/delete_lr_format_by_branch`,
  CHANGE_DEFAULT_STATUS: `branch/set_default_lr_format`,

  GET_EWAY_BILL: `ewayapi/`,
  EWAY_BILL_BY_DATE: `ewayapi/ewaybill/by-date`,
  EWAY_BILL_LIST_BY_DATE: `ewayapi/ewblist/by-date`,
  EWAY_BILL_TIMELINE: `ewayapi/ewaybill/timeline`,
  EWAY_BILL_STATUS_CHANGE: `ewayapi/ewaybill/update-ignore-status`,
  UPDATE_COMPANY_SETTING: `company/update_setting_to_company`,
  PAYMENT_BANK_LIST: `payment_approval/get_bank_list`,
  PAYMENT_EXCEL: `payment_approval/payment_approval/in_excel`,
  UPDATE_TRIP: `trip/update_trip`,
  EWAY_GENERATE_AUTH_TOKEN: `ewayapi/generate-auth-token`,
  DRIVER_CONSENT: `simtracking/update_driver_consent`,
  FATCH_LOCATION: `simtracking/fetch_location`,
  TRIP_FETCH_LOCATION: `simtracking/trip_location`,
  CALCULATE_DISTACE: `ewayapi/distance/calculate`,
  UPDATE_LR_INFORMATION: `ewayapi/update-lr-info`,

  // vehicle document type
  GET_VEHICLE_DOC_TYPE_LIST: `vehicle_document/get-doc-types`,
  CREATE_VEHICLE_DOC_TYPE: `vehicle_document/add_Doctype`,
  EDIT_VEHICLE_DOC_TYPE: `vehicle_document/update-doc-types`,
  DELETE_VEHICLE_DOC_TYPE: `vehicle_document/del-doc-types`,
  GET_SINGLE_VEHICLE_DOC_TYPE: `settings/get_vehicle_group`,

  GET_VEHICLE_DOCUMENTS_LIST: `vehicle_document/vehicle-documents`,
  CREATE_VEHICLE_DOCUMENTS: `vehicle_document/add_Document`,
  EDIT_VEHICLE_DOCUMENTS: `vehicle_document/vehicle-documents`,
  DELETE_VEHICLE_DOCUMENT: `vehicle_document/vehicle-documents`,
  GET_SINGLE_VEHICLE_DOCUMENT: `settings/get_vehicle_group`,

  // vehicle GPS setings
  UPDATE_VEHICLE_GPS_SETTINGS: `account/update_setting_to_vehicle`,
  DELETE_IMAGE: `common/delete_file`,
  DELETE_IMAGE_VEHICLE_DOCUMENT: `vehicle_document/delete-vehicle-doc-file`,

  // NEW VEHICLE DETAILS
  VEHICLE_DOC_COUNT: `vehicle_document/vehicle_doc_count`,
  VEHICLE_DETAIL_LIST: `vehicle_document/vehicle_detailed_list`,
  VEHICLE_SUMMARY_LIST: `vehicle_document/vehicle_summary_list`,
  VEHICLE_DOC_COUNTS: `vehicle_document/vehicle_doc_summary_count`,
  EXPORT_VEHICLE_DOCUMENT_SUMMARY: `vehicle_document/vehicle_summary_report`,
  VEHICLE_DOCUMENT_FETCH: `vehicle_document/vehicle_doc_fetch`,
  VEHICLE_DOCUMENT_COUNTS: `vehicle_document/vehicle_doc_summary_count`,

  // new gps time line 

  GPSTIMELINE: `v2/timeline/running`,
  GPS_SUMMARY: `v2/timeline/summary`,
  GPS_STOPPAGE: `v2/timeline/stoppage`,
  GPS_TIMELINE: `v2/complete_timeline/trip`,

  TRIP_GPS_SUMMARY: `v2/timeline_summary/trip`,
  TRIP_GPS_PARKED: `v2/timeline_with_parked_status/trip`,
  TRIP_GPS_RUNNING: `v2/timeline_with_running_status/trip`,

  CREATE_MASTER_LOCATION: `account/add_consignor_location`,
  UPDATE_MASTER_LOCATION: '',
  GET_ALL_COMPANY_FORMATE: `company/invoice_format_by_master`,
  ADD_INVOICE_FORMAT: `company/add_invoice_format_to_company`,
  GET_INVOICE_FORMAT_BY_COMPANY: `company/invoice_format_by_company`,
  GPS_TIME_LINE_DATA: `v2/timeline/complete`,

  LR_EXCEL_REPORT: `reports/get/billraiseReport/in_excel`,
  GET_PDF_LR_BILL_RAISE: `billraise/print_lr_billraise`,
  DOWNLOAD_PDF: `billraise/download_lr_billraise`,
  LR_DELETE_FROM_SUMMARY_DETAILS: `billraise/remove_lr_from_billraise`,
  CLAIM_DELETE_FROM_SUMMARY_DETAILS: `billraise/remove_claim_from_billraise`,
  TRANSACTION_DELETE_FROM_SUMMARY_DETAILS: `billraise/remove_payment_from_billraise`,
  BILL_RAISE_SERIES: `branch/get_billraise_number`,
  //
  FETCH_ADD_EWAY_BILL: `ewayapi/consignee-unit/create`,
  ACTION_PERMISSION: `company/allow_action_permission`,
  INVOICE_TRANSACTION: `dispatch/consignor_lr_transactions`,
  GET_USABLITY: `company/subscription_detail`,
  GET_WALLET_TRANSACTION: `ledger/getUsabilityLog`,
  ACTION_PERMISSION: `company/allow_action_permission`,
  INVOICE_TRANSACTION: `dispatch/consignor_lr_transactions`,
  // Dashboard Vehicle 
  GET_VEHICLE_DASHBOARD_DATA: `/v3/vehicle_dashboard/all`,
  GET_ON_TRIP_VEHICLE: `/v3/vehicle_dashboard/on_trip`,
  GET_AVAILABLE_VEHICLE: `/v3/vehicle_dashboard/not_on_trip`,
  GET_NO_GPS_VEHICLE: `/v3/dashboard/no_signal`,
  GET_NEW_GPS_VEHICLE: `/v3/fetch/gps_vehicles`,
  SUBSCRIPTION_LIST: `company/subscription_list`,

  IDFC_GET_ACCOUNTS: `/idfc/get-accounts`,
  IDFC_REGISTER_USER: `/idfc/register-user`,
  IDFC_DEREGISTER_USER: `/idfc/deregister-user`,
  GaN_PANELITY_IMPORT: "dispatch/import_gan_panelty",
  CREATE_ORDER_PAYMENT: `payment_approval/create_order`,
  PAYMENT_VERIFY: `payment_approval/order_verify`,
  DISCOUNT_CODE:`company/apply_coupon`,

  GET_IDFC_AUTH_URL: `/idfc/getAuthURL`,
  GET_IDFC_BALANCE: `/idfc/balance-enquiry`,
  IDFC_SESSION_LOGOUT: `/idfc/session-logout`,
  IDFC_UPDATE_ACCOUNT: `/idfc/update-account`,
  IDFC_REGISTER_ENQUIRY: `/idfc/register-enquiry`,
  IDFC_MULTI_PAYMENT: `/idfc/multi-payment`,
  IDFC_GET_ACCOUNT_DETAIL: `/idfc/get-account-detail`,
  IDFC_MULTI_PAYMENT_ENQUIRY: `/idfc/multi-payment-enquiry`,

  // Invoice details invoice lr pod 
  GET_INVOICE_LR_POD: `lr/lr-with-pod`,
  DOWNLOAD_N_PRINT_INVOICE_LR_POD: `lr/print_lr_pod`,
  PREVIEW_PRINT_INVOICE_LR_POD: `lr/get_lrPodUrl`,

  // invoice 
  GET_PENDING_LR_LIST: `billraise/pending_lr_for_billraise`,
  GET_PENDING_CLAIM_LIST: `billraise/pending_claim_for_billraise`,

  GET_VEHICLE_DASHBOARD_COUNTS: `/v3/dashboard/fleet_count`,
  SUPPLIER_TRIP_REPORT: `sheet_api/supplier/trip_sheet`,
  SUPPLIER_REPORT_DOWNLOAD: `sheet_api/supplier/print_trip_sheet`,
  SUPPLIER_TRIP_REPORT2: `sheet_api/supplier/trip_ledger`,
  SUPPLIER_REPORT_DOWNLOAD2: `sheet_api/supplier/print_trip_ledger`,
  GET_ALL_VEHICLES_LAT_LNG: `/v3/dashboard_fleet_loc`,

  UPDATE_SUPPLIER: `account/update_setting_to_supplier`,
  UPDATE_ADDRESS_BOOK: `account/update_setting_to_addressbook`,
  SEND_MESSAGE: `trip/share_trip_information`,
  COMPANY_CHECK: `company/action_create_company`,
  LR_DELETE_TRIP: `trip/remove_lr_from_trip`,
  SUPPLIER_TRIP_LIST: `trip/supplier_trip_list`,
  MAKE_TRIP_SUPPLIER_PAYMENT: `dispatch/supplier_bulk_transaction`,
  SUPPLIER_PAYMENT_LIST: `dispatch/get_payment_list`,
  SUPPLIER_PAYMENT_DELETE: `dispatch/delete_transaction`,
  DRIVER_TRIP_REPORT: `sheet_api/own/driver_trip_sheet`,
  DRIVER_REPORT_DOWNLOAD: `sheet_api/own/print_driver_trip_sheet`,
  FASTAGS_LIST: `fastag/list_fastag`,
  FASTAG_TRANSACTION: `fastag/list_fastag_txn`,
  FASTAG_DETAILS: `fastag/fastag_detail`,
  TRIP_DROPDOWN_LIST: `common/get_trip_for_dropdown`,
  ASSIGN_TRANSACTION: `fastag/fastag_txn_assigned_to_trip`,

  INVOICE_REPORT_VIEW_API: `sheet_api/lr/invoice/print`,
  INVOICE_REPORT_DOWNLOAD_API: `sheet_api/lr/invoice/print_report`,

  POD_LR_UPDATE: `lr/pod/update`,
  TRANSACTIONS_REPORT: `sheet_api/acc/accounting_ledger`,
  ADD_BALANCE_WALLET: `payment_approval/add_balance`,
  ADD_GENERAL_RECIEPT_ACCOUNT: `dispatch/create_receipt_voucher`,
  ADD_BALANCE_VERIFY: `payment_approval/verify_balance_addition`,
  GET_LANGUAGES: `language/get_language`,

  // work shop store
  CREATE_WORKSHOP: `service/add_store`,
  UPDATE_WORKSHOP: `service/edit_store`,
  GET_WORKSHOP_LIST: `service/get_store`,
  GET_SINGLE_WORKSHOP: `branch/get_branch`,
  PARTY_LR_REPORT: `sheet_api/party/ledger`,
  PARTY_LR_REPORT_DOWNLOAD: `sheet_api/party/ledger/print`,
  DELETE_WORKSHOP: `service/delete_disable_store`,
  SUPER_ADMIN_LOGIN: `user/login_as_company`,

  // work shop part category
  CREATE_PART_CATEGORY: `service/add_part_category`,
  UPDATE_PART_CATEGORY: `service/edit_part_category`,
  GET_PART_CATEGORY_LIST: `service/get_part_category`,
  GET_SINGLE_PART_CATEGORY: `branch/get_branch`,
  DELETE_PART_CATEGORY: `service/delete_disable_part_category`,
  GET_MEASUREMENT_LIST: `service/category_units`,
  ADD_SERVICE: `dispatch/create_servicing`,
  GET_SERVICE: `service/get_servicing`,
  GET_GST_MASTER_LIST: `common/gst_master`,

  // work shop manufacturor
  CREATE_MANUFACTURER: `service/add_manufacture`,
  UPDATE_MANUFACTURER: `service/edit_manufacture`,
  GET_MANUFACTURER_LIST: `service/get_manufacture`,
  DELETE_MANUFACTURER: `service/delete_disable_manufacture`,

  // work shop manufacturor
  // CREATE_ITEMS: `service/add_manufacture`,
  // UPDATE_ITEMS: `service/edit_manufacture`,
  // GET_ITEMS_LIST: `service/get_manufacture`,
  // DELETE_ITEMS: `service/delete_disable_manufacture`,

  // work shop items
  CREATE_ITEMS: `service/add_item`,
  UPDATE_ITEMS: `service/edit_item`,
  GET_ITEMS_LIST: `service/get_item`,
  DELETE_ITEMS: `service/delete_disable_item`,

  UPDATE_CHAROF_EXPENSE_CATEGORY: `chart_account/update_expense_category`,
  DELETE_CHAROF_EXPENSE_CATEGORY: `chart_account/delete_expense_category`,
  SHEET: `sheet_api`,
  ADJUST_BALANCE: `account/create_vendor_adjustment`,
  ADD_PURCHESE_BILL: `service/add_purchase_bill`,
  GET_PURCHASE_BILL_LIST: `service/get_purchase_bill_list`,
  DELETE_PURCHASE_BILL: `service/delete_disable_purchase_bill`,

  // service remainder
  GET_SERVICE_REMAINDER_LIST: `service/get_service_reminder_list`,
  SERVICE_REMAINDER_COUNT: `service/get_service_reminder_count`,
  CREATE_SERVICES_REM: `service/service_reminder`,
  MARK_SERVICES_REM: `service/mark_complete`,

  EXPORT_VEHICLE_DOCUMENT_SINGLE: `vehicle_document/single_vehicle_document_report`,
  DELETE_SERVICE_REMAINDER: `service/delete_service_reminder`,
  MAKE_PAYMENT_SERVICE: `dispatch/make_payment_servicing`,
  MONEY_IN: `dispatch/money_in`,
  MONEY_OUT: `dispatch/money_out`,
  GET_VOUCHER_REPORT: `dispatch/print_voucher`,
  GET_FUEL_REPORT: `account/print_fuel_statement`,

  // setting firm
  FIRM: `firm/`,
  GET_SETTINGS_FIRM: `firm/firm_list`,
  GET_SINGLE_FIRM: `firm/get_firm`,
  GET_USER_FIRM: `user/get_user_firms`,
  CREATE_SETTINGS_FIRM: `firm/create_firm`,
  UPDATE_SETTINGS_FIRM: `firm/update_firm`,
  DOWNLOAD_VOUCHER: `dispatch/download_voucher`,
  GET_TO_FIRM: `interfirm/list_association`,
  ADD_ASSOCIATED_FIRM: `interfirm/add_association`,
  INTRE_FIRM_TRIP_DETAILS: `dispatch/trip_interfirm_transactions`,
  ACCOUNT_EXPORT_EXCEL: `sheet_api/acc/accounting_ledger/in_excel`,
  TRIP_REPORT_SUMMARY_EXCEL: `reports/trip_report/summary/in_excel`,
  EXPORT_FUEL_STATION_TRANSACTION:`ledger/getFuelStatement/in_excel`,
  COMPARISION_PALN:`company/plan_comparision`,
  UPDATE_ASSOCIATED_FIRM:`interfirm/update_association`,
  GET_EASEBUZZ_DETAILS:`easebuzz/get-configuration`,
  VERIFY_EASEBUZZ_CONFIG:`easebuzz/verify-configuration`,
  COMPARISION_PALN: `company/plan_comparision`,
  UPDATE_ASSOCIATED_FIRM: `interfirm/update_association`,
  GET_EASEBUZZ_DETAILS: `easebuzz/get-configuration`,
  MAKE_PAYMENT_PAYNOW:`easebuzz/make-payment`,
  PAYMENT_DETAILS_PAYNOW:`dispatch/preview_payment_voucher`,
  PAYNOW_STATEMENT_DOWNLOAD:`easebuzz/paynow_statement`,
  GET_PAYMENT_STETMENT_DOWNLOAD: `easebuzz/paynow-statements`

};

export default {
  ...API,
};
